export const wurGreen = '#008A00';
export const wurGreenLight = '#00b300';
export const wurBlue = '#005172';

export const wurTextGrey = '#DEDCCF';

export const mainBackground = '#98cde3'; //`#67cfe3`; //'#229cd2';
export const panelBackground = '#f9f9f9f0';
export const headerBackground = '#fff';
export const footerBackground = panelBackground; //'#229cd2';

export const uiPrimaryColor = wurGreen;

export const warnColor = '#ff6f4b';
